import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
//import {areasreducer as areasData} from '../reducers/areasreducer'
import { composeWithDevTools } from "@redux-devtools/extension";
import { Listingreducer as ListingData } from "../reducers/listingreducer";
import { pushtokenreducer as notificationInfo } from '../reducers/pushnotificationreducer'
import { notificationsreducer as notificationdata } from '../reducers/notificationsreducer'
import { authreducer as auth } from "../reducers/authreducer";
import { AIreducer as aidata } from "../reducers/aireducers";
import { bookingoffersreducer as bookingoffersdata } from "../reducers/bookingoffersreducer";
import { practicetypesreducer as practicetypes } from "../reducers/practicetypesreducer";
import { regionreducer as regionData } from "../reducers/regionreducer";
import { devicereducer as currentDevice } from "../reducers/currentdeivceinforeducer";
import { commercialtypesreducer as commercialptypes } from "../reducers/commercialtypesreducer";
import { industrialtypesreducer as industrialptypes } from "../reducers/industrialtypesreducer";
import { usertypesreducer as usertypes } from "../reducers/usertypesreducer";
import { bookingslistreducer as bookinglistdata } from "../reducers/bookingslistreducer";
import { enquiryreducer as enquirydata } from "../reducers/enquiryreducer";
import { branchesreducer as branchData } from "../reducers/branchesreducer";
import { estimatereducer as estimatedata } from "../reducers/estimatereducer";
import { cancelreasonreducer as cancelreasondata } from "../reducers/cancelreasonreducer";
import { promoreducer as promodata } from "../reducers/promoreducer";
import { usersreducer as usersdata } from "../reducers/usersreducer";
import { brokerearningreducer as brokerearningdata } from "../reducers/brokerearningreducer";
import { earningreportsreducer as earningreportsdata } from "../reducers/earningreportsreducer";
import { settingsreducer as settingsdata } from "../reducers/settingsreducer";
import { paymentreducer as paymentmethods } from "../reducers/paymentreducer";
import { eventreducer as eventdata } from "../reducers/eventreducer";
import { tasklistreducer as taskdata } from "../reducers/tasklistreducer";
import { locationreducer as locationdata } from "../reducers/locationreducer";
import { chatreducer as chatdata } from "../reducers/chatreducer";
import { brokernotesreducer as brokernotesdata } from "../reducers/brokernotesreducer";
import { withdrawreducer as withdrawdata } from "../reducers/withdrawreducer";
import { gpsreducer as gpsdata } from "../reducers/gpsreducer";
import { treatmenttypesreducer as treatmenttypes } from "../reducers/TreatmentTypeReducer";
import { medicalHistoryReducer as medicalRecords } from "../reducers/medicalhistoryreducer";
import { meetingroomreducer as meetingroomdata } from "../reducers/meetingroomreducer";
import { openfireuserreducer as openfireuserdata } from "../reducers/openfireuserreducer";
import { referralsreducer as referrals } from "../reducers/referralsreducer";
import { referralbrokersreducer as referralbrokers } from "../reducers/referralbrokersreducer";
import { Brokersreducer as brokers } from "../reducers/Brokersreducer";
import { matchingreducer as matchingdata } from "../reducers/matchingreducer";
import { canvasreducer as canvasdata } from "../reducers/canvasreducer";
import { leadsreducer as leaddata } from "../reducers/leadsreducer";

import { tokenReducer as tokendata } from "../reducers/tokenreducer";

// import {chatsreducer} from '../reducers/chatsreducer';
import { publishreducer as publishdata } from "../reducers/publishreducer";
import { contactreducer as contactdata } from "../reducers/contactreducer";
import { jmuserreducer as jmuserdata } from "../reducers/contactreducer";
import { agentsreducer as agentsdata } from "../reducers/agentsreducer";
import { areasreducer as areaData } from "../reducers/areasreducer";
import { brokerreducer as brokersdata } from "../reducers/brokerreducer";
import { citiesreducer as citiesdata } from "../reducers/citiesreducer";
import { landlordReducer as landlorddata } from "../reducers/landlordreducer";

// import {notificationsreducer} from '../reducers/notificationsreducer';
const reducers = combineReducers({
  notificationdata,
  matchingdata,
  auth,
  agentsdata,
  practicetypes,
  treatmenttypes,
  bookinglistdata,
  aidata,
  estimatedata,
  ListingData,
  regionData,
  enquirydata,
  branchData,
  cancelreasondata,
  promodata,
  usersdata,
  tokendata,
  bookingoffersdata,
  meetingroomdata,
  brokerearningdata,
  earningreportsdata,
  settingsdata,
  brokers,
  paymentmethods,
  eventdata,
  currentDevice,
  landlorddata,
  taskdata,
  locationdata,
  chatdata,
  brokernotesdata,
  withdrawdata,
  medicalRecords,
  gpsdata,
  commercialptypes,
  industrialptypes,
  notificationInfo,
  usertypes,
  referrals,
  referralbrokers,
  openfireuserdata,
  canvasdata,
  publishdata,
  contactdata,
  jmuserdata,
  areaData,
  brokersdata,
  citiesdata,
  leaddata
});

let middleware = [thunk];

export const store = createStore(
  reducers,
  {},
  composeWithDevTools(applyMiddleware(...middleware))
);
